import {
  TeamOutlined,
  CalendarOutlined,
  ShoppingCartOutlined,
  DollarCircleOutlined
} from '@ant-design/icons'
import React from 'react'
import { routesConfig } from './routes'

export interface ModuleItem {
  title: string
  route: string
}

export interface Module {
  title: string
  icon: React.ReactNode
  submenu: ModuleItem[]
}

export const menuConfig: Module[] = [
  {
    title: 'Agendas',
    icon: React.createElement(CalendarOutlined),
    submenu: [
      {
        title: 'Contatos',
        route: routesConfig.activities.calendar.list
      }
    ]
  },
  {
    title: 'Empresas',
    icon: React.createElement(TeamOutlined),
    submenu: [
      {
        title: 'Clientes',
        route: routesConfig.customers.customer.list
      }
    ]
  },
  {
    title: 'Vendas',
    icon: React.createElement(ShoppingCartOutlined),
    submenu: [
      {
        title: 'Oportunidades',
        route: routesConfig.oportunities.oportunity.list
      },
      {
        title: 'Pedidos',
        route: routesConfig.orders.order.list
      },
      {
        title: 'Ordens de Serviço',
        route: routesConfig.ordersOfService.serviceOrder.list
      }
    ]
  },
  {
    title: 'Financeiro',
    icon: React.createElement(DollarCircleOutlined),
    submenu: [
      {
        title: 'Contratos',
        route: routesConfig.contracts.contract.list
      }
    ]
  }
]
